/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useHistory } from 'react-router-dom';
import { BadgeCheckIcon } from '@heroicons/react/solid';

//vlinder libs
import { useViewport } from '@vlinder-web/viewport-provider-react';
import { LoggerModule } from '@vlinder-web/logger-module-react';
import { FBGridV, FBItemV } from 'react-flexbox-grid-rs';

import {
  BackButton,
  ProvenanceStepSubtitle,
  ProvenanceStepTitle,
  ImageVideoGallery,
  TabSection,
  ButtonV,
  ChipList,
  SignatureProvStep,
} from '../components';
import { useTheme } from '../../../providers/theme';

const log: any = LoggerModule?.getInstance();

interface ContaierSMProps {
  data: any;
  onVerifyCredential?(): void;
  staticData?: any;
  type?: string;
}

export const ContainerSM = ({
  data,
  onVerifyCredential,
  staticData,
  type,
}: ContaierSMProps) => {
  const { bp, width } = useViewport();
  const { colors } = useTheme();
  const history = useHistory();

  const onBackButtonPress = () => {
    history.go(-1);
  };

  const _getButtonStyle = () => {
    let _style: any = {};
    _style = {
      minWidth: bp === 'xs' || 'sm' ? width * 0.6 : '250px',
      maxWidth: bp === 'xs' || 'sm' ? width * 0.8 : '250px',
      backgroundColor: colors?.primaryDark,
    };

    return _style;
  };

  if (type === 'venus') {
    console.log('venus provance details :', data);
    return (
      <SignatureProvStep data={data} onBackButtonPress={onBackButtonPress} />
    );
  } else {
    console.log(`data?.ChipList :`, data?.ChipList);
    return (
      <View style={StyleSheet.flatten([styles.container])}>
        {data && data?.provenanceStepTitle && (
          <ProvenanceStepTitle title={data?.provenanceStepTitle?.title} />
        )}

        <FBGridV>
          <FBItemV colspan={22}>
            {data && data?.provenanceStepSubtitle && (
              <ProvenanceStepSubtitle
                title={data?.provenanceStepSubtitle?.subtitle}
              />
            )}
          </FBItemV>
          <FBItemV colspan={2}>
            {data?.isVerified && (
              <BadgeCheckIcon color='green' width={'22px'} />
            )}
          </FBItemV>
        </FBGridV>

        <BackButton onBackPress={onBackButtonPress} />

        {/* {data && data?.PROV_STEP_TITLE_CARD && (
                <div style={{ marginTop: "30px" }}>
                    <ProvStepTitleCard
                        title={data?.PROV_STEP_TITLE_CARD?.title}
                        logo={data?.PROV_STEP_TITLE_CARD?.logo}
                        extraInfo={data?.PROV_STEP_TITLE_CARD?.extraInfo}
                    />
                </div>
            )} */}

        {data &&
          data?.images &&
          Array.isArray(data?.images) &&
          data?.images.length > 0 && (
            <ImageVideoGallery images={data?.images} />
          )}
        {data &&
          data?.ChipList &&
          data?.ChipList?.chipItems &&
          data?.ChipList?.chipItems.length > 0 && (
            <ChipList
              chipItems={data?.ChipList?.chipItems}
              staticData={staticData?.chipList}
            />
          )}

        {data && data?.provenanceDetailInfo && (
          <div style={{ paddingTop: '20px' }}>
            <TabSection
              // onListItemPress={_onListItemPress}

              // provStepTitleCardProps={BP?.ProvStepTitleCard}
              // chipListProps={BP?.ChipList}
              // provDetailInfoProps={BP?.ProvDetailInfo}
              // provInfoList={BP?.ProvDetailInfo?.provInfoList}
              // aboutProvInfo={BP?.ProvDetailInfo?.aboutProvInfo}
              // provStepHeading={BP?.ProvDetailInfo?.title}
              // provMapProps={BP?.provMapProps}

              provStepHeading={data?.provenanceDetailInfo?.title}
              aboutProvInfo={data?.provenanceDetailInfo?.aboutProvInfo}
              provInfoList={data?.provenanceDetailInfo?.provInfoList}
              geoJson={data?.provenanceDetailInfo?.provGeoJson}
              defaultCenter={data?.provenanceDetailInfo?.defaultCenter}
              defaultZoom={data?.provenanceDetailInfo?.defaultZoom}
              googleMapAPIKey={data?.provenanceDetailInfo?.googleMapAPIKey}
              // geoJson={BP?.provMapProps?.geojson}
              bp={bp}
            />
            {/* {!data?.isVerified && (
            <div style={StyleSheet.flatten([styles.buttonContainerStyle])}>
              <ButtonV
                buttonText={"Verify Data on Blockchain"}
                onClick={onVerifyCredential}
                buttonStyle={StyleSheet.flatten([
                  styles?.buttonStyle,
                  _getButtonStyle(),
                ])}
              />
            </div>
          )} */}
            {data?.credentialURL && (
              <div style={StyleSheet.flatten([styles.buttonContainerStyle])}>
                <ButtonV
                  buttonText={'Verify Signature on Blockchain'}
                  onClick={() => window.open(data?.credentialURL)}
                  buttonStyle={StyleSheet.flatten([
                    styles?.buttonStyle,
                    _getButtonStyle(),
                  ])}
                />
              </div>
            )}
          </div>
        )}
        {/* {props?.data?.credentialURL &&
                is.not.empty(props?.data?.credentialURL) &&
                is.existy(props?.data?.credentialURL) &&
                is.url(props?.data?.credentialURL) && (
                    <FabButton
                        onFabClick={() => {
                            window.open(
                                `${props?.data?.credentialURL}`,
                                "_blank"
                            );
                        }}
                    />
                )} */}
      </View>
    );
  }
};

const styles = StyleSheet.create({
  container: {
    // flex: 1,
    // alignItems: 'center',
    // justifyContent: 'center',
    // paddingTop: 20,
  },
  buttonStyle: {
    marginTop: '10px',
    marginBottom: '20px',
  },
  buttonContainerStyle: {
    display: 'flex',
    justifyContent: 'center',
  },
});
